import React from 'react'
import { useGetCustomersLazyQuery } from 'services/customers'
import { Button, Stack } from '@mui/material_modern'
import { AddCircle as AddCircleIcon } from '@mui/icons-material_modern'
import store from 'state/store'
import { showFormModal } from 'state/ui'
import FORM_MODALS from 'utils/ui/modals'
import AsyncAutocomplete from '.'

interface CustomerAutocompleteProps {
  name: string
  label?: string
  'data-test'?: string
  variant?: string
  size?: string
  defaultValue?: {
    id?: string
    customerCommonIdentifierString?: string
    companyName?: string
  } | null
  freeSolo?: boolean
  control: any
  error?: boolean
  helperText?: string
  onCustomersLoad?: () => void
  onChange?: (value: any) => void
  labelKey?: string
  autocompleteProps?: any
  baseFilter?: any
  quickAdd?: boolean
  formModalProps?: any
  stackProps?: any
  disabled?: boolean
  intercompany?: boolean
}

const CustomerAutocomplete: React.FC<CustomerAutocompleteProps> = ({
  name,
  variant = 'standard',
  control,
  defaultValue = null,
  freeSolo = true,
  onCustomersLoad = () => {},
  onChange = (value: any) => {},
  labelKey = 'customerCommonIdentifierString',
  autocompleteProps = {},
  baseFilter = {},
  quickAdd = false,
  formModalProps = {},
  stackProps = {},
  disabled = false,
  intercompany = false,
  ...restProps
}) => {
  const filter = intercompany ? { ...baseFilter, type: 'YARD' } : baseFilter
  return (
    <Stack direction="row" width="100%" {...stackProps}>
      <AsyncAutocomplete
        name={name}
        control={control}
        defaultValue={defaultValue}
        labelKey={labelKey}
        useGetOptionsLazyQuery={useGetCustomersLazyQuery}
        autoSelect
        freeSolo={freeSolo}
        onDataLoad={onCustomersLoad}
        onChange={onChange}
        autocompleteProps={autocompleteProps}
        baseFilter={filter}
        passInputValueToSearchFilter
        pageSize={100}
        disabled={disabled}
        variant={variant}
        {...restProps}
      />
      {quickAdd && (
        <Button
          variant="text"
          startIcon={
            <AddCircleIcon
              sx={{
                minWidth: 'unset',
                marginRight: -1.5,
                marginLeft: 0,
              }}
            />
          }
          sx={{
            minWidth: 'unset',
            marginRight: -0.5,
            marginLeft: 0,
          }}
          onClick={() =>
            store.dispatch(
              showFormModal({
                formModalName: FORM_MODALS.NEW_CUSTOMER,
                formModalProps: {
                  type: baseFilter?.type?.toLowerCase(),
                  ...formModalProps,
                },
              }),
            )
          }
          disabled={disabled}
        />
      )}
    </Stack>
  )
}

export default CustomerAutocomplete
